import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { PriceDisplay } from './ui/PriceDisplay';
import { CheckCircleIcon } from 'lucide-react';
export function FinalCTA() {
  const items = [<>
      <strong data-id="element-122">Acceso a Biblia Visual</strong> — 500+ páginas, 280+ imágenes HD
    </>, 'Formato Digital', <>
      <strong data-id="element-123">7 Bonus Incluidos Gratis</strong>
    </>, 'Actualizaciones de por vida', <>
      <strong data-id="element-124">Garantía de 120 días</strong>
    </>];
  return <section className="py-14 bg-navy text-white relative overflow-hidden" data-id="element-125">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-126"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-127">
        <FadeIn data-id="element-128">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-gold mb-8" data-id="element-129">
            Una Vez Más, Todo Lo Que Recibirás
          </h2>

          <div className="bg-navy-800/80 backdrop-blur-sm border border-gold/30 rounded-2xl p-6 md:p-8 shadow-2xl max-w-2xl mx-auto" data-id="element-130">
            <ul className="space-y-3 mb-6 text-left" data-id="element-131">
              {items.map((item, index) => <li key={index} className="flex items-start gap-2.5" data-id="element-132">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-133" />
                  <span className="text-base md:text-lg text-gray-200 font-medium" data-id="element-134">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="pt-6 border-t border-navy-700 mb-6" data-id="element-135">
              <p className="text-gray-400 font-medium mb-1 text-sm" data-id="element-136">
                Valor total:{' '}
                <span className="line-through text-red-400" data-id="element-137">$171.99+</span>
              </p>
              <p className="text-lg text-gray-300 mb-3" data-id="element-138">Pago único hoy:</p>
              <PriceDisplay amount={9.99} size="xl" lightText className="mb-6" data-id="element-139" />

              <Button fullWidth className="py-5 text-lg md:text-xl mb-3 shadow-[0_0_30px_rgba(201,168,76,0.4)] animate-pulse-slow" data-id="element-140">
                AGREGAR AL CARRITO
              </Button>
              <p className="text-gold-400 font-medium text-sm" data-id="element-141">
                Acceso inmediato a Biblia Visual + Todos los Bonos »
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}